import { lazy } from 'react';

// React.lazy for a named export. Returns the lazy component plus a `preload`
// function that starts the download early (e.g. while the browser is idle).
export function lazyNamed(loader, name) {
  const load = () => loader().then(m => ({ default: m[name] }));
  const Component = lazy(load);
  Component.preload = loader;
  return Component;
}

// Warm the given lazy components once the page has finished loading and the
// browser is idle, so they never compete with what the visitor sees first.
export function preloadWhenIdle(...components) {
  let idle, timer;
  const run = () => components.forEach(c => c.preload());
  const schedule = () => {
    timer = setTimeout(() => {
      if ('requestIdleCallback' in window) idle = window.requestIdleCallback(run, { timeout: 4000 });
      else run();
    }, 800);
  };
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
  return () => {
    window.removeEventListener('load', schedule);
    clearTimeout(timer);
    if (idle && 'cancelIdleCallback' in window) window.cancelIdleCallback(idle);
  };
}
